import { createPortal } from 'react-dom';
import React, { useContext, useState, useEffect, useRef } from 'react';
import { withStyles, Grid, Divider } from '@material-ui/core';
import DataContext from '../../data/DataContext';
import { openLink } from '../../util/utilNative';
// import IconMore from "../../../asset/img/btn_more_nor.svg";
// import IconMorePressed from "../../../asset/img/btn_more_sel.png";
// import IconBadge from "../../../asset/img/ico_flag_newProd.png";
import IconArrowUp from '../../../asset/img/ico_arrow_up.svg';
import IconArrowDown from '../../../asset/img/ico_arrow_down.svg';
import IconAddPrd from '../../../asset/img/ico_add_prd.svg';
import IconOutlink from '../../../asset/img/icon_outlink.svg';
import Modal from '../../modal/Modal';
import Close from '../../../asset/img/icon_close.svg';

const styles = (theme) => ({
  root: {
    position: 'relative',
    letterSpacing: '-0.0313rem',
    margin: '1rem 0rem',
    zIndex: 10,
  },
  listitem: {
    width: '100%',
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    width: 'auto',
    height: 'auto',
    // flex: "auto",
    borderRadius: '0.625rem',
    backgroundColor: '#fff',
    boxShadow: '0 0.25rem 0.5rem 0 rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    margin: '0.1875rem 1rem',
    position: 'relative',
  },
  prdInfo: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    height: 'auto',
    padding: '1.25rem 0 0 0 ',
  },
  prdInfoIcon: {
    minWidth: '2.5rem',
    minHeight: '2.5rem',
    width: '2.5rem',
    height: '2.5rem',
    borderRadius: '50%',
    backgroundColor: '#f4f4f4',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 0 0 1rem',
  },
  prdInfoIconImg: {
    width: '1.5rem',
    height: '1.5rem',
  },
  prdInfoDesc: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    margin: '0 0 1.25rem 0.75rem',
  },
  prdInfoDescTitle: {
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    color: '#000',
    // marginBlockStart: "0",
    // marginBlockEnd: "0.3rem",
    // lineHeight:1.29,
    marginRight: '0.125rem',
    background: 'none',
    border: 'none',
    textAlign: 'left',
    padding: '0',
  },
  prdInfoDescTitleBox: {
    // display: "flex",
    // flexDirection: "row",
    // alignItems: "center",
    marginBottom: '0.3rem',
    lineHeight: 1,
    // position: "absolute"
  },
  prdInfoDescDetail: {
    fontSize: theme.font.size12,
    color: '#666',
    marginBlockStart: '0',
    marginBlockEnd: '0',
  },
  prdInfoButtonOpen: {
    display: 'flex',
    margin: '0.75rem 1rem 0 0',
    backgroundColor: '#fff',
    border: '0px',
    padding: '0',
    '& img': {
      width: '20px',
    },
  },
  prdButtonGrid: {
    margin: '0 1rem 0.625rem 1rem',
  },
  prdButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '0px',
    borderRadius: '0.375rem',
    backgroundColor: '#eee',
    fontSize: theme.font.size12,
    fontWeight: 'bold',
    minHeight: '32px',
    color: '#222',
  },

  moreItemButton: {
    width: '100%',
    backgroundColor: '#eee',
    border: '0px',
    borderRadius: '0.375rem',
    margin: '0 1rem',
  },
  moreItemText: {
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    // color: theme.color.text,
    color: '#000',
    textAlign: 'center',
  },
  moreItemCard: {
    display: 'flex',
    width: '100%',
    backgroundColor: 'transparent',
    margin: '0.8125rem 0 0 0',
    minHeight: '2.875rem',
  },
  prdUserInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 1.125rem 0.75rem 1.125rem',
    minHeight: '1.3125rem',
  },
  prdUserTitle: {
    fontSize: theme.font.size15,
    fontWeight: 'bold',
    color: '#000',
  },
  prdUserTitleStr: {
    marginBlockStart: 0,
    marginBlockEnd: 0,
  },
  prdUserCount: {
    color: '#ea1917', //"#da0f47"
  },
  prdMoreItem: {
    fontSize: theme.font.size12,
    color: '#666',
    textDecoration: 'underline',
    border: 'none',
    backgroundColor: 'transparent',
  },
  addPrdCard: {
    width: 'auto',
    height: 'auto',
    borderRadius: '0.625rem',
    backgroundColor: '#fff',
    boxShadow: '0 0.25rem 0.5rem 0 rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    margin: '0.1875rem 1rem',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  addPrdIcon: {
    margin: '1.25rem 0 0 0',
    backgroundImage: `url(${IconAddPrd})`,
    minWidth: '1.5rem',
    minHeight: '1.5rem',
    backgroundRepeat: 'no-repeat',
    cursor: 'pointer',
  },
  addPrdStr: {
    fontSize: theme.font.size14,
    color: '#000',
    textAlign: 'center',
    margin: '0.25rem 0',
  },
  addPrdButton: {
    width: '-webkit-fill-available',
    border: '0px',
    fontWeight: 'bold',
    fontSize: theme.font.size14,
    borderRadius: '0.375rem',
    backgroundColor: '#eee',
    margin: '1rem',
    minHeight: '2.5rem',
    color: '#222',
    cursor: 'pointer',
  },
  linkStr: {
    // color: "-webkit-link",
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  outLinkImg: {
    position: 'relative',
    verticalAlign: 'middle',
  },
  rootWholeList: {
    display: 'flex',
  },
  drawerContainer: {
    width: '100%',
    position: 'fixed',
    zIndex: '1300',
    inset: '0',
  },
  drawerFrame: {
    borderRadius: '0.625rem',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    height: '70%',
    overflowY: 'auto',
    transform: 'none',
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
    top: 'auto',
    left: '0',
    right: '0',
    bottom: '0',
    height: '70%',
    display: 'flex',
    zIndex: '1200',
    position: 'fixed',
    overflowY: 'auto',
    flexDirection: 'column',
    boxShadow:
      '0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
    color: 'rgba(0, 0, 0, 0.87)',
    backgroundColor: '#fff',
  },
  drawerRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  dialogContainerBackdrop: {
    opacity: '1',
    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    display: 'flex',
    zIndex: '-1',
    position: 'fixed',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  dividerTitle: {
    height: '0.0625rem',
    background: '#000',
    margin: '0rem 0.875rem 1.2188rem 0.875rem',
  },
  titleClose: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    padding: '0.0625rem 0rem',
  },
  close: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '1.5rem',
      height: '1.5rem',
      cursor: 'pointer',
    },
  },
  btnClose: {
    border: 'none',
    background: 'none',
  },
  drawerHeaderClose: {
    position: 'fixed',
    height: '4.375rem',
    background: '#fff',
    width: '100%',
    zIndex: '1',
    borderRadius: '0.625rem',
  },
  closeContainer: {
    display: 'flex',
    minHeight: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.625rem 1rem',
  },
  componentWrapper: {
    overflowY: 'auto',
    paddingTop: '4.375rem',
  },
});

const isURLValid = (strUrl) => {
  let expUrl = /^http[s]?:\/\/([\S]{3,})/i;
  return expUrl.test(strUrl);
};

const PRDCard = withStyles(styles)(({ classes, data, index, modalClose }) => {
  const [buttonOpen, setButtonOpen] = useState(index === 0 ? true : false);
  const descTitle = data.product_title;
  const descDetail = `${data.product_group_name} | ${data.product_model}`;
  const iconUrl = data.product_icon_url;
  const productLinkUrl = data.product_link_url;
  const context = useContext(DataContext);

  const buttonArray = data?.button || [];
  const isOdd = buttonArray.length % 2 !== 0;

  const gridSizeFull = 12;
  const gridSizeHalf = 6;

  const buttonHandler = (button) => {
    if (button.type.toLowerCase() === 'action_backend') {
      context.request(context, button.speech, 'button', button.parameters, button.expect);
    } else {
      context.request(context, button.speech, 'button');
    }
    modalClose && modalClose();
  };

  const handleButtonOpen = () => {
    if (buttonArray.length > 0) {
      setButtonOpen(!buttonOpen);
    }
  };
  // const noImgPath = `${window.location.protocol}//${window.location.host}/image/icon_product_no_icon`
  const etcImgPath = `${window.location.protocol}//${window.location.host}/image/icon_product_etc`;
  const handleImgError = (e) => {
    e.target.src = `${etcImgPath}.svg`;
  };

  const openProductLink = () => {
    if (productLinkUrl) {
      openLink(context, 'external', productLinkUrl);
    }
  };

  return (
    <div className={classes.card}>
      <div className={classes.prdInfo}>
        <div className={classes.prdInfoIcon}>
          {iconUrl && isURLValid(iconUrl) ? (
            <img
              className={classes.prdInfoIconImg}
              src={iconUrl}
              onError={handleImgError}
              alt=""
            />
          ) : (
            <img
              className={classes.prdInfoIconImg}
              src={`${etcImgPath}.svg`}
              // src={`${noImgPath}.png`}
              // srcSet={`${noImgPath}@2x.png 2x, ${noImgPath}@3x 3x`}
            />
          )}
        </div>
        <div className={classes.prdInfoDesc}>
          <div className={classes.prdInfoDescTitleBox}>
            {productLinkUrl ? (
              <button
                className={`${classes.prdInfoDescTitle} ${classes.linkStr}`}
                onClick={() => openProductLink()}
                dangerouslySetInnerHTML={{ __html: descTitle }}
              ></button>
            ) : (
              <span
                className={`${classes.prdInfoDescTitle}`}
                onClick={() => openProductLink()}
                dangerouslySetInnerHTML={{ __html: descTitle }}
              ></span>
            )}

            {productLinkUrl && (
              <span className={classes.outLinkImg}>
                <img src={IconOutlink} alt="새창열림" />
              </span>
            )}
          </div>
          <p className={classes.prdInfoDescDetail}>{descDetail}</p>
        </div>
        <button
          disabled={buttonArray.length <= 0}
          className={classes.prdInfoButtonOpen}
          onClick={handleButtonOpen}
          aria-expanded={buttonOpen}
        >
          <img
            src={buttonOpen ? IconArrowUp : IconArrowDown}
            alt={`${descTitle} 메뉴 더보기`}
          />
        </button>
      </div>
      {buttonOpen && (
        <div className={classes.prdButtonGrid}>
          <Grid container spacing={1}>
            {buttonArray.map((item, index) => {
              const gridSize =
                isOdd && buttonArray.length >= 3 && index >= buttonArray.length - 2
                  ? gridSizeHalf
                  : gridSizeFull;
              return (
                <Grid item xs={gridSize} key={`prdc-grid-${index}`}>
                  <button
                    className={classes.prdButton}
                    onClick={() => {
                      buttonHandler(item);
                    }}
                  >
                    {item.label}
                  </button>
                </Grid>
              );
            })}
          </Grid>
        </div>
      )}
    </div>
  );
});

const AddPrd = withStyles(styles)((props) => {
  const { classes, data } = props;
  const context = useContext(DataContext);

  const handleAddProdClick = () => {
    openLink(context, 'external', data.manage_products_url);
    let list_items = [
      {
        label: context.string.chat.goMyProductsButton,
        speech: context.string.chat.goMyProductsButton,
      },
    ];
    context.addSLMessage(false, context.string.chat.goMyProductsText, list_items);
  };
  return (
    <div className={classes.addPrdCard}>
      <div className={classes.addPrdIcon} onClick={handleAddProdClick}></div>
      <div className={classes.addPrdStr}>
        보유제품을 등록하시면 더 간단하게
        <br />
        문제를 해결할 수 있어요
      </div>
      <button className={classes.addPrdButton} onClick={handleAddProdClick}>
        5초 만에 보유제품 등록하기
      </button>
    </div>
  );
});

function PRDC(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const maxVisibleItemLength = 2;
  const featureMoreItems = data.items.length > maxVisibleItemLength;
  const userName = data?.user_name || context.string.chat.anonymousName;
  const [modalOpen, setModalOpen] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    if (modalOpen) {
      // 웹접근성 - 모달팝업 포커스 25-01
      const { current: modalElement } = modalRef;
      window.setTimeout(() => {
        modalElement.focus();
      });
    }
  }, [modalOpen]);

  const modalClose = () => {
    setModalOpen(false);

    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }
  };

  const handleMoreItemClick = (data) => {
    // todo - PRDC 더보기 구현
    // openLink(context, action, url, event);
    console.log("need to make 'more items' webview page");
    setModalOpen(true);

    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].setAttribute('aria-hidden', 'true');
    }
  };

  const curItemLen = data.items.length;
  const endIndex =
    curItemLen <= maxVisibleItemLength
      ? curItemLen
      : curItemLen - (curItemLen - maxVisibleItemLength);

  let prdList = data.items.slice(0, endIndex).map((item, key) => (
    <div key={`prdList${key}`} className={classes.listitem}>
      <PRDCard data={item} index={key} />
    </div>
  ));

  // const WholeList = React.forwardRef((props, ref) => (
  //   <div className={classes.rootWholeList}>
  //     {data.items.map((item, key) => (
  //       <div key={`wholeList${key}`} className={classes.listitem}>
  //         <PRDCard data={item} index={key} modalClose={modalClose} />
  //       </div>
  //     ))}
  //   </div>
  // ));

  return (
    <div>
      <div className={classes.root}>
        <div className={classes.prdUserInfo}>
          <div className={classes.prdUserTitle}>
            <p className={classes.prdUserTitleStr}>
              {userName}님의 보유제품{' '}
              <span className={classes.prdUserCount}>{curItemLen}</span>{' '}
            </p>
          </div>
          {featureMoreItems && (
            <button className={classes.prdMoreItem} onClick={handleMoreItemClick}>
              더보기
            </button>
          )}
        </div>
        {curItemLen > 0 ? prdList : <AddPrd data={data} />}
      </div>
      {/* <Modal
        component={withStyles(styles)(wholeList)}
        anchor="bottom"
        title={`${userName}님의 보유제품을 \n 보여드릴게요.`}
        data={data}
        modalOpen={modalOpen}
        modalClose={modalClose}
        height="70%"
        borderRadius="10px"
        closeType="close-top"
      /> */}
      {createPortal(
        <div className={classes.rootWholeList}>
          {modalOpen && (
            <div className={classes.drawerContainer}>
              <div className={classes.dialogContainerBackdrop} aria-hidden="true"></div>
              <div className={classes.drawerFrame}>
                <div className={classes.drawerRoot}>
                  <div className={classes.drawerHeaderClose}>
                    <div className={classes.closeContainer}>
                      <div className={classes.titleClose} ref={modalRef} tabIndex="0">
                        {`${userName}님의 보유제품을 보여드릴게요.`}
                      </div>
                      <div className={classes.close}>
                        <button className={classes.btnClose} onClick={modalClose}>
                          <img src={Close} className={classes.arrowDown} alt="닫기" />
                        </button>
                      </div>
                    </div>
                    <Divider classes={{ root: classes.dividerTitle }} />
                  </div>
                  <div className={classes.componentWrapper}>
                    {data.items.map((item, key) => (
                      <div key={`wholeList${key}`} className={classes.listitem}>
                        <PRDCard data={item} index={key} modalClose={modalClose} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>,
        document.getElementById('modal')
      )}
    </div>
  );
}
export default withStyles(styles)(PRDC);
